import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createMilk } from '../thunk';

import type { MilkInputType } from '@/domain/milk/component/MilkFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import MilkFormInput from '@/domain/milk/component/MilkFormInput';
import { MeasureDateTime } from '@/domain/milk/service/entity/valueObjects/measureDateTime';
import { parseTimeByCurrentDate } from '@/utils/date';

/** プロパティ */
export type AddMilkInput = {
  /** 開くか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 日付 */
  date?: Date,
};

const AddMilk: React.FC<AddMilkInput> = ({
  isOpen,
  close,
  user,
  child,
  facilityList,
  date,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<MilkInputType>({
    defaultValues: {
      milk: 100,
      measureDateTime: MeasureDateTime.toStringTime(new Date(), false),
    },
  });
  const onSubmit = (input: MilkInputType) => {
    const username = user.name;
    dispatch(createMilk({
      data: {
        data: {
          measureDateTime: parseTimeByCurrentDate(input.measureDateTime, date).toJSON(),
          milk: input.milk,
          measurerId: username,
          measurerType: 'app',
          parentId: username,
          childId: child.childId,
        },
        pub: {
          sendId: `${child.parentId}_${child.childId}`,
          replyId: username,
          data: {},
        },
      },
      facilityIds: facilityList.map((v) => v.data.facilityId),
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ minWidth: '300px' }}
      >
        <DialogTitle title="ミルクの登録" />
        <DialogContent>
          <MilkFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddMilk;
